import get from 'lodash/get';
import PropTypes from 'prop-types';

import DownloadArtifactButton from './DownloadArtifactButton';

const DownloadInvoiceButton = props => {
  const {iconOnly, textOnly, session} = props;
  return (
    <DownloadArtifactButton 
      {...props}
      session={session}
      docType='invoice'
      iconOnly={iconOnly}
      textOnly={textOnly}
    />
  );
};

DownloadInvoiceButton.defaultProps = {
  iconOnly: false,
  textOnly: false,
};

DownloadInvoiceButton.propTypes = {
  session: PropTypes.object,
  iconOnly: PropTypes.bool,
};

export default DownloadInvoiceButton;
